import { IAttachment } from "interfaces/entities/ticket";
import { ITransaction } from "interfaces/entities/transaction";
import { TransactionType } from "store/entities/transaction/interfaces";

import { IRequestResult } from "../api-client";
import { BaseApi } from "../base";

interface ICreateTransactionParams {
  ticketID?: string;
  agentID?: string;
  cannedResponseID?: string;
  type?: TransactionType;
}

interface IMergeAttachmentsParams {
  agentID?: string;
  cannedResponseID?: string;
}

export class TransactionsApi extends BaseApi {
  protected readonly prefix = "transactions";

  create = (params: ICreateTransactionParams): Promise<IRequestResult<ITransaction>> =>
    this.post("", params) as Promise<IRequestResult<ITransaction>>;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (transactionID: string) => this.get(`${transactionID}`);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uploadAttachment = async (
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attachment: any,
    transactionID: string,
    onProgress: (event: ProgressEvent) => void,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    xhr: (xhr: XMLHttpRequest, body: any) => void
  ) => {
    const formData = new FormData();
    formData.append("attachments", attachment);
    return this.postWithProgress<IRequestResult<IAttachment>>(
      `${transactionID}/attachments`,
      formData,
      {},
      this.prefix,
      onProgress,
      xhr
    );
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  mergeAttachments = (transactionID: string, params: IMergeAttachmentsParams) =>
    this.post(`${transactionID}/attachments`, params);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteAttachment = async (attachmentID: string, transactionID: string) =>
    this.delete(`${transactionID}/attachments/${attachmentID}`);
}
